import { render, staticRenderFns } from "./veStuAssocActivityTypeShow.vue?vue&type=template&id=0bdcc7e8&scoped=true"
import script from "./veStuAssocActivityTypeShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityTypeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcc7e8",
  null
  
)

export default component.exports